import React, { useState, useEffect } from "react";
import { QwantaProvider, useAuth, Ide, Guest } from "qwanyx";

// Domain mapping configuration with optional title and favicon properties
const DOMAIN_CONFIGS = {
  // autodin.be domain - with title and favicon

  "autodin.be": {
    _id: "684fc5280c53a28884b5912b",
    di: "645b5e00c7b61df466430901",
    ed: "67ebed7ccdd8254087f5ebff",
    pa: "68259607c759715cc50b4490",
    title: "Autodin - Digital Solutions",
    favicon: "/favicons/autodin-favicon.png"
  },


  /*"autodin.be": {
    _id: "67ebed89cdd8254087f5ec00",
    di: "645b5e00c7b61df466430901",
    ed: "67ebed7ccdd8254087f5ebff",
    pa: "67ebef80cdd8254087f5ec01",
    title: "Autodin - Digital Solutions",
    favicon: "/favicons/autodin-favicon.png"
  },*/
  // pixanima.com domain - with title only
  "pixanima.com": {
    _id: "68109497248ec89481ce4c2c",
    ed: "67fb8993cfe765b2ff5a547c",
    di: "645b5e00c7b61df466430901",
    pa: "68109497248ec89481ce4c2b",
    title: "Pixanima",
    favicon: "/favicons/pixanima-icon.svg"
    // No favicon specified yet
  },
  // belgicomics.qwanyx.com domain - no custom title or favicon yet
  "belgicomics.qwanyx.com": {
    _id: "6800054250a69b4343ec8d1f",
    ed: "67fb90386b9543e462ff7fbc",
    di: "645b5e00c7b61df466430901",
    pa: "680b4bf80238f6fa0cef1dd5",
    title: "Belgicomics",
    favicon: "/favicons/belgicomics-favicon.png"
  },
  "test.qwanyx.com": {
    _id: "682f783954edb74b5f775c96",
    ed: "6811055f1e7723d290d4e194",
    di: "645b5e00c7b61df466430901",
    pa: "68259607c759715cc50b4490",
    title: "Qwanyx Test Environment",
    favicon: "/favicons/qwanyx-favicon.png"
  },
  "alex.qwanyx.com": {
    _id: "680777da07dcd9f56d3d0ed2",
    ed: "680777ba3afccd68bc4e6dae",
    di: "68075c6fad1d28fe9788472b",
    pa: "680779acc62faaf9315f4131",
    title: "Alex",
    favicon: "/favicons/qwanyx-favicon.png"
  },
  "virtualframer.qwanyx.com": {
    _id: "6808b821277b1216d2d1a091",
    ed: "677f5a055eaec5447a8c5d35",
    di: "645b5e00c7b61df466430901",
    pa: "6808b821277b1216d2d1a090",
    title: "Virtual Framer",
    favicon: "/favicons/qwanyx-favicon.png"
  },
  "academiegretry.qwanyx.com": {
    _id: "6809e4a2cd0443dcdb6cf502",
    ed: "677f5a055eaec5447a8c5d35",
    di: "645b5e00c7b61df466430901",
    pa: "6809e4a2cd0443dcdb6cf501",
    title: "academiegretry",
    favicon: "/favicons/qwanyx-favicon.png"
  },
  "tian.qwanyx.com": {
    _id: "6850589cc65961df0ecc3c38",
    ed: "677f5a055eaec5447a8c5d35",
    di: "645b5e00c7b61df466430901",
    pa: "68259607c759715cc50b4490",
    title: "Tian Coenen",
    favicon: "/favicons/qwanyx-favicon.png"
  },
  "qwanyx.com": {
    _id: "6811055f1e7723d290d4e194",
    ed: "67e7c50d7f5a60e716664e70",
    di: "645b5e00c7b61df466430901",
    pa: "6811055f1e7723d290d4e193",
    title: "Qwanyx",
    favicon: "/favicons/qwanyx-favicon.png"
  }
  // Add more domains as needed in the same format
};

const DEFAULT_CONFIG = {
  _id: "6811055f1e7723d290d4e194", // qwanyx.com
  di: "645b5e00c7b61df466430901",
  ed: "67e7c50d7f5a60e716664e70",
  pa: "6811055f1e7723d290d4e193",
  title: "Qwanyx",
  favicon: "/favicons/qwanyx-favicon.png"
};

// Helper function to update favicon
const setFavicon = (faviconPath) => {
  const links = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');

  // Remove any existing favicons
  links.forEach(link => {
    document.head.removeChild(link);
  });

  // Create and append new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = faviconPath;
  document.head.appendChild(link);
};

const QwanyxApp = () => {
  const { currentUser, logged } = useAuth(); // Get the current user from AuthProvider

  // Initialize selectedCard state
  const [selectedCard, setSelectedCard] = useState(DEFAULT_CONFIG);

  // Determine which domain is being accessed and set the corresponding configuration
  useEffect(() => {
    let currentDomain = window.location.hostname;
    console.log("Current domain:", currentDomain);

    // Remove 'www.' prefix if present
    if (currentDomain.startsWith('www.')) {
      currentDomain = currentDomain.substring(4);
    }

    // Check if we have a configuration for this domain
    let config = DOMAIN_CONFIGS[currentDomain] || DEFAULT_CONFIG;

    // Update the selected card
    setSelectedCard(config);

    // Set the page title if specified
    if (config.title) {
      document.title = config.title;
    }

    // Set the favicon only if specified
    if (config.favicon) {
      setFavicon(config.favicon);
    }

  }, []);

  // Styling for the app wrapper
  const style = {
    width: "100%",
    height: "100vh", // Adjust height to fit the viewport
    overflow: "hidden", // Prevent scrollbars
    backgroundColor: "white",
    zIndex: 1,
  };

  // Show loading state while authenticating
  if (!logged) {
    return (
      <div>
        {selectedCard && selectedCard._id && (
          <Guest initialCard={selectedCard} />
        )}
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div style={style}>
      <Ide currentUser={currentUser}>
        <QwantaProvider
          _id={currentUser?.id || "guest"} // Fallback to "guest" if no ID
        // embedEditor={false}
        // qwantum={qwantumDefaults}
        >
          {/* Main app UI */}
          <div>Welcome, {currentUser?.profile?.email || "Guest"}!</div>
        </QwantaProvider>
      </Ide>
    </div>
  );
};

export default QwanyxApp;
